import React from 'react';
import type { IconProps } from './types';

// Document/notes glyph (folded corner + text lines). `strokeWidth` is tunable
// because it appears at a few visual weights across the app.
const NoteDocIcon: React.FC<IconProps & { strokeWidth?: number }> = ({
  size = 18,
  color = 'currentColor',
  strokeWidth = 1.8,
  ...props
}) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
    <path d="M5 4.5A1.5 1.5 0 0 1 6.5 3h11A1.5 1.5 0 0 1 19 4.5v10.9a1.5 1.5 0 0 1-.44 1.06l-3.1 3.1a1.5 1.5 0 0 1-1.06.44H6.5A1.5 1.5 0 0 1 5 18.5v-14Z" />
    <path d="M14.5 20v-4a1 1 0 0 1 1-1h3.5" />
    <path d="M8.5 8.5h7M8.5 12h5" />
  </svg>
);

export default NoteDocIcon;
